import { useSearchParams } from "react-router-dom";
import { portfolioAnalysisPages } from "@app/const/route.const";
import { ModulePerformanceRiskReport } from "./ModulePerformanceRiskReport";

export const OUT_UNDER_PERFORMANCE_CHART_HEIGHT = 176;

export const PdfPortfolioAnalysisPerformanceRiskReportPage = () => {
  const [searchParams] = useSearchParams();
  const { portfolioGroupId, moduleId, data1Id, data2Id, startYear, endYear } =
    portfolioAnalysisPages.getPdfPerformanceRiskReportParams(searchParams);

  return (
    <ModulePerformanceRiskReport
      portfolioGroupId={portfolioGroupId}
      moduleId={moduleId}
      startYear={startYear}
      endYear={endYear}
      data1Id={data1Id}
      data2Id={data2Id}
      footer="Portfolio Analysis"
    />
  );
};
